export const getTemplate = (template, context, recipient) => {
  const footer = `
    <hr>
    <p> To stop receiving emails from podPlease please click here: \
    <a href="${process.env.GATSBY_WEB_URL}/user_management?mode=unsubscribe&email=${recipient}">
    Unsubscribe
    </a> \
    </p>
  `
  switch (template) {
    case "created":
      return {
        subject: `Whale hello there! ${context.podName} was created.`,
        body: `
        <p>Congratulations! Your pod was created. Please save this email. \
        You will receive emails from applicants until you deactivate or delete \
        your pod from the listings. </p>

        <p> Pod Name: ${context.podName} </p>

        <a href="${process.env.GATSBY_WEB_URL}/profile?id=${context.id}"> \
        View your pod here
        </a>

        <br>

        <a href="${process.env.GATSBY_WEB_URL}/edit"> Edit your pod here: </a>

        <p> Remember, follow our safety and scam guidelines. \
        PodPlease is a listing service, we are not responsible for activities outside of \
        the platform. </p>

        ${footer}
      `,
      }
    case "application - applicant":
      return {
        subject: `Whale isn't that something? You've applied to ${context.podName}.`,
        body: `
        <p> Congratulations, you've successfully applied for ${context.podName}. \
        Keep an eye on the horizon for an email from the pod owner. Feel free to search \
        and <a href="${process.env.GATSBY_WEB_URL}/find"> apply to more pods </a> while you wait. \
        Don't delete this email. You may need it later. </p>

        <a href="${process.env.GATSBY_WEB_URL}/profile?id=${context.id}">
          View ${context.podName} here
        </a>

        <br>

        <p>Remember to follow our safety and spam guidelines. PodPlease is a listing \
        service. We are not responsible for activities outside of the platform. </p> \

        ${footer}
      `,
      }
    case "application - owner":
      return {
        subject: `Whale, that's flippin' amazing! You've got an applicant.`,
        body: `
        <p> Your pod has an applicant. If they have your seal of approval, feel free \
        to reach out to them! </p>
        <p style=color:"red">Remember to follow our safety and spam guidelines. PodPlease is a listing \
        service. We are not responsible for activities outside of the platform. </p> \
        
        <p> Name: ${context.name || "Not specified"} </p>
        <p> Phone number: ${context.phoneNumber} </p>
        <p> Email: ${context.emailAddress} </p>
        <p> Facebook: ${context.facebook || "Not specified"} </p>
        <p> LinkedIn: ${context.linkedIn || "Not specified"} </p>
        <p> Instagram: ${context.instagram || "Not specified"} </p>

        <p> <b> Tell the pod owner a little about your family: </b> </p>

        <p> ${
          context.application || "The applicant didn't provide any information"
        } </p>

        <a href="${process.env.GATSBY_WEB_URL}/edit" >
          Need to close your pod? Edit your pod here
        </a>
        ${footer}
        `,
      }
    case "rejected":
      // Placeholder, we want to be notified whenever an email bounces or
      // is sent to an unsubscribed user
      return {}
    case "reported":
      return {
        subject: `Oh Blubber, someone's reported pod ${context.podName}`,
        body: `
        <p>Oh no! Someone reported this pod:</p>
        <p>${context.podName}</p>

        <p>The pod was created by:</p>
        <p>${context.emailAddress}</p>

        <a href="${process.env.GATSBY_WEB_URL}/profile?id=${context.id}"> \
        View the reported pod here
        </a>
        
        <p>Here's the reporter's included message:</p>
        <p>${context.report}</p>

        `,
      }
  }
}
